// Widget
export enum LegacyWidgetCode {
    WDGT_ACTIONS_RIGHT_ACCESS = 'wdgt_actions',
    WDGT_BUILDING_ACTION_SUMMARY_RIGHT_ACCESS = 'wdgt_building_action_summary',
    WDGT_BUILDING_PERFORMANT_SITES_RIGHT_ACCESS = 'wdgt_building_performant_sites',
    WDGT_ENERGY_EXPENDITURE_BALANCE_RIGHT_ACCESS = 'wdgt_energy_expenditure_balance',
    WDGT_ENERGY_BALANCE_BY_USAGE_RIGHT_ACCESS = 'wdgt_energy_balance_by_usage',
    WDGT_ENERGY_EFFICIENTY_RATING_RIGHT_ACCESS = 'wdgt_energy_efficiency_rating',
    WDGT_ENERGY_BALANCE_TABLE_RIGHT_ACCESS = 'wdgt_energy_balance_table',
    WDGT_HOME_FAV_SENSORS_RIGHT_ACCESS = 'wdgt_home_fav_sensors',
    WDGT_HOME_TILES_RIGHT_ACCESS = 'wdgt_home_tiles',
    WDGT_NODE_INFO_RIGHT_ACCESS = 'wdgt_node_info',
    WDG_IPE_TILES = 'wdgt_ipe_tiles',
    WDGT_PERIODS_LIST = 'wdgt_periods_list',
    WDG_BUDGET_VISION_RIGHT_ACCESS = 'wdgt_budget_vision',
    WDG_MONOSITE_ONLY_RIGHT_ACCESS = 'wdgt_monosite_only',
    WDGT_MINI_CONTRACT_OPTIMIZATION = 'wdgt_mini_contract_optimization',
    WDGT_MINI_MISSING_INVOICES = 'wdgt_mini_missing_invoices',
    WDGT_MINI_INVOICE_ERRORS = 'wdgt_mini_invoice_errors',
    WDGT_SECTION_TITLE = 'wdgt_section_title',
    WDGT_CONTACT_LIST = 'wdgt_contact_list',
    WDGT_HTML_FREESTYLE = 'wdgt_html_freestyle',
    WDGT_CUSTOM_PICTURE = 'wdgt_custom_picture',
    WDGT_SINGLE_SENSOR = 'wdgt_single_sensor',
    WDGT_YEARLY_INDICATOR = 'wdgt_yearly_indicator',

    // new engine widgets
    // TO REMOVE AFTER DATABASE UPDATE
    WDGT_HISTOGRAM = 'wdgt_histogram',
    WDGT_TABLE = 'wdgt_table',
    WDGT_TOP_FLOP = 'wdgt_top_flop',
    WDGT_POINTS_CLOUD = 'wdgt_points_cloud'
}

export enum LegacyDashboardRight {
    DSHB_ENERGY_PERF = 'dshb_energy_perf',
    DSHB_REAL_TIME = 'dshb_real_time',
    DSHB_CITY_WATER = 'dshb_city_water',
    DSHB_BUDGET = 'dshb_budget',
    DSHB_CO2 = 'dshb_co2',
    DSHB_DECREE = 'dshb_decree',
    DSHB_BUSINESS_INDICATOR = 'dshb_business_indicator' // It's use like a prefix, there are many dshb_business_indicator rights like dshb_business_indicator_{$id}
}

// Main-menu (left menu)
export const COMPARISON_ACCESS = 'comparison';
export const MAPS_RIGHT_ACCESS = 'maps';
export const DATA_ACCESS = 'data';
export const DATA_QUALIFICATION_RIGHT_ACCESS = 'access_data_quality';
export const ALERTS_RIGHT_ACCESS = 'alerts'; // and widget
export const ACTIONS_RIGHT_ACCESS = 'actions'; // and widget
export const REPORT_ACCESS = 'report';
export const EXPORT_ACCESS = 'export';
export const MANAGED_ENTITY_ACCESS = 'managed_entity_access';
export const DASHAVIZ_ACCESS = 'dashaviz_access';
export const DOCUMENT_MANAGEMENT_SYSTEM_ACCESS = 'document_management_system_access';
export const NEW_DELIVERY_POINTS_PAGE = 'new_delivery_points_page';
export const NEW_BUILDINGS_PAGE = 'new_buildings_page';
export const DATABOARD_PAGE = 'databoards';
export const SEN_ANALYSIS_ACCESS = 'sen_analysis';
export const DEET_VIEWER_ACCESS = 'deet_viewer';
export const DEET_ADMIN_ACCESS = 'deet_admin';
export const AUTOMATON_ACCESS = 'automaton';
export const IOT_SUPERVISION = 'iot_supervision';
export const RECOMMENDED_ACTIONS_PAGE_ACCESS = 'recommended_actions_page';
export const MIP_VIEWER_ACCESS = 'mip_viewer';
export const CONTRACT_POWER_OPTIMIZATION = 'contract_power_optimization';

// = isProjectAdmin
export const ACCESS_PROJECT_ADMINISTRATION = 'access_project_administration';

// Action menu (top menu)
export const CREATE_BUILDING_RIGHT_ACCESS = 'create_building';
export const SUPPLIERS_PORTAL_ACCESS = 'suppliers_portal_access';
export const IMPORT_PDF_BILLS_RIGHT_ACCESS = 'import_pdf_bills'; // and in page
export const CREATE_PROJECT_RIGHT_ACCESS = 'create_project';

// Action menu profile
export const CONNECTED_AS_RIGHT_ACCESS = 'connected_as';

// Specific feature
export const INVOICE_REFERENCE_EDITION_ACCESS = 'invoice_reference_edition';
export const DELETE_METER = 'delete_meter';
export const BUDGET_LOCK_RIGHT_ACCESS = 'budget_lock';
export const BUDGET_EDITION_RIGHT_ACCESS = 'budget_edition';
export const MANAGED_ENTITY_IMPORT_DATA_ACCESS = 'managed_entity_import_data';
export const CAN_USE_INTERNAL_PROJECT_DASHBOARDS = 'can_use_internal_project_dashboards';
export const CAN_SYNCHRONIZE_SUPPLIER_PORTAL_ACCESS = 'can_synchronize_supplier_portal_access';

// Acces to internal module
export const ACCESS_INTERNAL_MODULE = 'access_internal_module';

export const DEVELOPER_MODE = 'developer_mode';

export const USER_DASHBOARD = 'user_dashboard';
